'use client'

import { useSyncExternalStore } from 'react'
import { getRefinerIdentified, subscribeRefinerIdentified } from './refiner'

/**
 * Whether the app has queued an identify for the current user.
 *
 * The server snapshot is always `false`, so the feedback tab is never in the
 * server HTML and appears only once the client knows who the user is.
 */
export default function useRefinerIdentified(): boolean {
  return useSyncExternalStore(subscribeRefinerIdentified, getRefinerIdentified, () => false)
}
